var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ff-envio az-text-ff-envio ia-block-card pa-4" },
    [
      _vm.resolvidoQualquer === "erro"
        ? [
            _c("div", { staticClass: "d-flex align-center az-gap-small" }, [
              _c("span", {
                staticClass: "ff-envio__ponto flex-shrink-0",
                style: { background: "var(--danger)" }
              }),
              _c(
                "span",
                { staticClass: "az-text-primary az-size-14 font-semibold" },
                [_vm._v(" Não foi possível enviar ")]
              )
            ]),
            _c("p", { staticClass: "ff-envio__texto az-size-12 mb-0 mt-1" }, [
              _vm._v(_vm._s(_vm.textoDoErro))
            ]),
            _c(
              "div",
              { staticClass: "d-flex justify-end mt-3" },
              [
                _c(
                  "BaseButton",
                  { attrs: { underlined: "" }, on: { click: _vm.fechar } },
                  [_vm._v("Fechar")]
                )
              ],
              1
            )
          ]
        : _vm.resolvidoQualquer === "enviado"
        ? [
            _c("div", { staticClass: "d-flex align-center az-gap-small" }, [
              _c("span", {
                staticClass: "ff-envio__ponto flex-shrink-0",
                style: { background: "var(--success)" }
              }),
              _c(
                "span",
                { staticClass: "az-text-primary az-size-14 font-semibold" },
                [_vm._v(" Relatório enviado ")]
              ),
              _c(
                "output",
                {
                  staticClass:
                    "ml-auto az-text-primary az-size-12 az-muted text-no-wrap",
                  attrs: { "data-teste": "envio-selo", "aria-live": "polite" }
                },
                [_vm._v(" " + _vm._s(_vm.selos.enviado) + " ")]
              )
            ]),
            _c(
              "p",
              {
                staticClass: "ff-envio__texto az-size-12 mb-0 mt-1",
                attrs: { "data-teste": "envio-recibo" }
              },
              [_vm._v(" " + _vm._s(_vm.linhaDoRecibo) + " ")]
            )
          ]
        : _vm.resolvidoQualquer === "cancelado"
        ? [
            _c("div", { staticClass: "d-flex align-center az-gap-small" }, [
              _c("span", {
                staticClass: "ff-envio__ponto flex-shrink-0",
                style: { background: "var(--neutral-400)" }
              }),
              _c(
                "span",
                { staticClass: "az-text-primary az-size-14 font-semibold" },
                [_vm._v(" Envio cancelado. ")]
              ),
              _c(
                "output",
                {
                  staticClass:
                    "ml-auto az-text-primary az-size-12 az-muted text-no-wrap",
                  attrs: { "aria-live": "polite" }
                },
                [_vm._v(" " + _vm._s(_vm.selos.cancelado) + " ")]
              )
            ])
          ]
        : _vm.processando
        ? [
            _c(
              "div",
              {
                staticClass:
                  "ff-envio__cabecalho d-flex align-center az-gap-small mb-3"
              },
              [
                _c("span", {
                  staticClass: "ff-envio__ponto flex-shrink-0",
                  style: { background: "var(--primary)" }
                }),
                _c(
                  "span",
                  { staticClass: "az-text-primary az-size-14 font-semibold" },
                  [_vm._v(" Enviar relatório por e-mail ")]
                ),
                _c(
                  "span",
                  {
                    staticClass:
                      "ml-auto ff-envio__texto az-size-12 text-no-wrap"
                  },
                  [_vm._v(" " + _vm._s(_vm.contextoDoCartao) + " ")]
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "d-flex align-center mb-4",
                attrs: { "aria-live": "polite" }
              },
              [
                _c("v-progress-circular", {
                  attrs: { indeterminate: "", size: "18", width: "2" }
                }),
                _c("span", { staticClass: "ff-envio__texto ml-3" }, [
                  _vm._v(_vm._s(_vm.textoDaEtapa))
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "d-flex justify-end" },
              [
                _c(
                  "BaseButton",
                  { attrs: { underlined: "" }, on: { click: _vm.cancelar } },
                  [_vm._v("Cancelar")]
                )
              ],
              1
            )
          ]
        : [
            _c(
              "div",
              {
                staticClass:
                  "ff-envio__cabecalho d-flex align-center az-gap-small mb-4"
              },
              [
                _c("span", {
                  staticClass: "ff-envio__ponto flex-shrink-0",
                  style: { background: "var(--primary)" }
                }),
                _c(
                  "span",
                  { staticClass: "az-text-primary az-size-14 font-semibold" },
                  [_vm._v(" Enviar relatório por e-mail ")]
                ),
                _c(
                  "span",
                  {
                    staticClass:
                      "ml-auto ff-envio__texto az-size-12 text-no-wrap",
                    attrs: { "data-teste": "envio-contexto" }
                  },
                  [_vm._v(" " + _vm._s(_vm.contextoDoCartao) + " ")]
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "ff-envio__linha d-flex align-start mb-3" },
              [
                _c(
                  "label",
                  {
                    staticClass: "ff-envio__rotulo az-text-ff-envio-rotulo",
                    attrs: { for: "ff-envio-destinatario" }
                  },
                  [_vm._v(" Para ")]
                ),
                _c(
                  "div",
                  { staticClass: "ff-envio__campo" },
                  [
                    _c("input-by-type", {
                      staticClass: "no-border",
                      attrs: {
                        id: "ff-envio-destinatario",
                        "id-input": "ff-envio-destinatario",
                        filled: "",
                        dense: "",
                        type: "text",
                        value: _vm.destinatario,
                        placeholder: "e-mail do cliente",
                        "error-messages": _vm.erroDoCampo,
                        "aria-describedby": "ff-envio-destinatario-erro"
                      },
                      on: {
                        input: function($event) {
                          _vm.destinatario = $event
                        },
                        blur: _vm.marcarTocado
                      }
                    }),
                    _vm.erroDoCampo
                      ? _c(
                          "p",
                          {
                            staticClass: "az-text-ff-envio-erro mb-0",
                            attrs: { id: "ff-envio-destinatario-erro" }
                          },
                          [_vm._v(" " + _vm._s(_vm.erroDoCampo) + " ")]
                        )
                      : _vm.avisoDoCadastro
                      ? _c("p", { staticClass: "az-text-small mb-0" }, [
                          _vm._v(" " + _vm._s(_vm.avisoDoCadastro) + " ")
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "ff-envio__linha d-flex align-start mb-3" },
              [
                _c(
                  "label",
                  {
                    staticClass: "ff-envio__rotulo az-text-ff-envio-rotulo",
                    attrs: { for: "ff-envio-assunto" }
                  },
                  [_vm._v(" Assunto ")]
                ),
                _c(
                  "div",
                  { staticClass: "ff-envio__campo" },
                  [
                    _c("input-by-type", {
                      staticClass: "no-border",
                      attrs: {
                        id: "ff-envio-assunto",
                        "id-input": "ff-envio-assunto",
                        filled: "",
                        dense: "",
                        type: "text",
                        value: _vm.assunto,
                        placeholder: "assunto do e-mail",
                        "error-messages": _vm.erroDoAssunto
                      },
                      on: {
                        input: function($event) {
                          _vm.assunto = $event
                        },
                        blur: _vm.marcarTocado
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "ff-envio__linha d-flex align-start mb-3" },
              [
                _c(
                  "label",
                  {
                    staticClass: "ff-envio__rotulo az-text-ff-envio-rotulo",
                    attrs: { for: "ff-envio-corpo" }
                  },
                  [_vm._v(" Mensagem ")]
                ),
                _c(
                  "div",
                  { staticClass: "ff-envio__campo" },
                  [
                    _c("input-by-type", {
                      staticClass: "no-border",
                      attrs: {
                        id: "ff-envio-corpo",
                        "id-input": "ff-envio-corpo",
                        filled: "",
                        dense: "",
                        type: "textarea",
                        value: _vm.corpo,
                        rows: 6,
                        placeholder: "mensagem do e-mail",
                        "error-messages": _vm.erroDoCorpo
                      },
                      on: {
                        input: function($event) {
                          _vm.corpo = $event
                        },
                        blur: _vm.marcarTocado
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "ff-envio__linha d-flex align-center mb-4" },
              [
                _c(
                  "span",
                  { staticClass: "ff-envio__rotulo az-text-ff-envio-rotulo" },
                  [_vm._v("Anexo")]
                ),
                _c("div", { staticClass: "ff-envio__campo" }, [
                  _c(
                    "span",
                    {
                      staticClass:
                        "ff-envio__anexo d-inline-flex align-center az-gap-xsmall",
                      attrs: { "data-teste": "envio-anexo" }
                    },
                    [
                      _c("icon-svg", {
                        attrs: {
                          name: "mdi-paperclip",
                          size: 14,
                          color: "var(--text-muted)"
                        }
                      }),
                      _c("span", { staticClass: "az-size-12" }, [
                        _vm._v(_vm._s(_vm.preview.nome_anexo))
                      ])
                    ],
                    1
                  )
                ])
              ]
            ),
            _c("div", { staticClass: "d-flex align-center az-gap-small" }, [
              _c("span", { staticClass: "ff-envio__texto az-size-12" }, [
                _vm._v(_vm._s(_vm.notaDoRodape))
              ]),
              _c(
                "div",
                { staticClass: "ml-auto d-flex align-center az-gap-small" },
                [
                  _c(
                    "BaseButton",
                    { attrs: { bordered: "" }, on: { click: _vm.cancelar } },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "BaseButton",
                    {
                      attrs: { primary: "", disabled: !_vm.podeEnviar },
                      on: { click: _vm.solicitarEnvio }
                    },
                    [_vm._v(" Enviar relatório ")]
                  )
                ],
                1
              )
            ])
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }